import { SearchState } from 'src/app/interfaces/search.interface';
import { SocialInitiativeActionsShared } from './social-initiative-actions-shared.abstract';
import { defineCallParams } from './social-initiative.helpers';

export abstract class SocialInitiativeActionsEntities extends SocialInitiativeActionsShared {
  public fetchPersonalEntities(state?: SearchState): void {
    const params: number[] = defineCallParams(null, state);
    this.fetchUserEntities(...params);
  }

  public fetchPersonalSpecificEntities(userId: string, state: SearchState): void {
    const paginationRelatedParams: number[] = defineCallParams(null, state);
    this.fetchUserSpecificEntities(userId, ...paginationRelatedParams);
  }

  public fetchEntityRelatedItems(entityId: string, state?: SearchState): void {
    const params: number[] = defineCallParams(null, state);
    this.fetchEntityRelatedItemsResolver(entityId, ...params);
  }

  public abstract fetchUserPersonalRequests(): void;
  public abstract fetchUserPersonalInvites(): void;

  protected abstract fetchUserEntities(offset?: number, limit?: number): void;
  protected abstract fetchUserSpecificEntities(userId: string, offset?: number, limit?: number): void;
  protected abstract fetchEntityRelatedItemsResolver(entityId: string, offset?: number, limit?: number): void;
}
